import { Seo } from "@/components/layout/Seo";
import { Hero } from "@/components/sections/Hero";
import { ExpertiseMarquee } from "@/components/sections/ExpertiseMarquee";
import { ServicesGrid } from "@/components/sections/ServicesGrid";
import { Organizations } from "@/components/sections/Organizations";
import { HowWeWork } from "@/components/sections/HowWeWork";
import { Principles } from "@/components/sections/Principles";
import { Areas } from "@/components/sections/Areas";
import { Questions } from "@/components/sections/Questions";
import { RegionalNote, FinalCta } from "@/components/sections/CallToActions";

export default function HomePage() {
  return (
    <>
      <Seo page="home" />
      <Hero />
      <ExpertiseMarquee />
      <ServicesGrid />
      <Organizations showLink />
      <HowWeWork showIntro />
      <Principles />
      <Areas />
      <Questions />
      <RegionalNote />
      <FinalCta />
    </>
  );
}
